"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.handleServiceError = void 0;
const constants_1 = require("@/app/shared/constants");
const serverError_1 = require("@/app/shared/helpers/serverError");
const effects_1 = require("redux-saga/effects");
const notifications_1 = require("./notifications");
const ERROR_CODES = [...Object.values(constants_1.SERVER_ERROR_CODES), ...Object.values(constants_1.CLIENT_ERROR_CODES)];
function* handleServiceError(error, fallbackToastId) {
    console.error('Handle service error:', error);
    const serverHtml = (0, serverError_1.getServerHtmlMessage)(error);
    if (serverHtml) {
        yield (0, effects_1.put)(notifications_1.notificationsActions.showToast({
            id: constants_1.TOAST_ERROR_ID.SCHEDULER_SERVER_HTML_MESSAGE,
            detail: serverHtml,
        }));
        return;
    }
    const errorMessage = error?.toString() || '';
    const errorCode = ERROR_CODES.find((code) => errorMessage.includes(code));
    const toastId = errorCode && constants_1.TOAST_CODE_ERRORS_LIST[errorCode];
    yield (0, effects_1.put)(notifications_1.notificationsActions.showToast({ id: toastId || fallbackToastId }));
}
exports.handleServiceError = handleServiceError;
